import { render, staticRenderFns } from "./LegacyRoleManagement.vue?vue&type=template&id=7839865e&scoped=true&lang=html&"
import script from "./LegacyRoleManagement.vue?vue&type=script&lang=js&"
export * from "./LegacyRoleManagement.vue?vue&type=script&lang=js&"
import style0 from "./LegacyRoleManagement.vue?vue&type=style&index=0&id=7839865e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7839865e",
  null
  
)

export default component.exports